import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ChangeDetectionStrategy, Output, EventEmitter
} from '@angular/core';
import { CATALOG_ROOT_ID, CustomerCatalogService } from "../services/customer-catalog.service";
import { CatalogCategory } from "../../../../../../compob2b-libs/src/lib/interfaces/CatalogSubcategories";
import { FileService } from "compob2b-libs";

@Component({
  selector: 'app-catalog-subcategories',
  templateUrl: './catalog-subcategories.component.html',
  styleUrls: ['./catalog-subcategories.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CatalogSubcategoriesComponent implements OnInit, OnChanges {
  @Input() categoryId!: number;
  noPhotoSrc = '/assets/images/product/nofoto.jpg';

  @Input() basePath: string = '/catalog';
  @Output() isLeaf = new EventEmitter<boolean>();

  subcategories: CatalogCategory[] = [];
  isLoading = false;
  hasError = false;

  constructor(
    private fileService: FileService,
    private catalogService: CustomerCatalogService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadSubcategories();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoryId'] && !changes['categoryId'].firstChange) {
      this.loadSubcategories();
    }
  }

  private loadSubcategories(): void {
    if (!this.categoryId) {
      this.categoryId = CATALOG_ROOT_ID
    };

    this.isLoading = true;
    this.hasError = false;

    this.catalogService.getSubcategories(this.categoryId).subscribe({
      next: (categories) => {
        console.log('categories', categories)
        if (Array.isArray(categories)) {
          this.subcategories = categories.filter(cat => cat.productCount > 0);
        }
        this.isLeaf.emit(this.subcategories.length === 0);
        this.isLoading = false;
        this.cdr.markForCheck();

      },
      error: () => {
        this.hasError = true;
        this.isLoading = false;
        this.cdr.markForCheck();
      },
    });
  }

  public getImageUri(picture: string) {
    return picture && picture != '.' ? this.fileService.getImageSrc(picture) : this.noPhotoSrc;
  }

  hasSubcategories(): boolean {
    return this.subcategories.length > 0;
  }

  trackById(_: number, category: CatalogCategory): number {
    return category.id;
  }
}
